import * as React from "react";
import LoginContainer from "containers/portal/authentication/LoginContainer";
import SessionLoginContainer from "containers/session/authentication/LoginContainer";
import { Route, Router, Switch } from "react-router-dom";
import { Container } from "reactstrap";
import SessionResetContainer from "./containers/session/SessionResetContainer";
import RetrievalsCallbackContainer from "./containers/shared/RetrievalsCallbackContainer";
import "./styles/marble.scss";
import history from "./utils/history";
import Overlay from "./components/shared/Overlay";
import AppInsightWrapper from "components/shared/AppInsightsWrapper";
import SessionTimeout from "components/authentication/portal/SessionTimeout";

const SessionSubRoute = React.lazy(() => import("./subroutes/SessionSubRoute"));
const PortalSubRoute = React.lazy(() => import("./subroutes/PortalSubRoute"));

const App = () => {
  return (
    <AppInsightWrapper>
      <React.Suspense fallback={<Overlay showLoading />}>
        <Container fluid className="pe-0 ps-0 h-100">
          <Router history={history}>
            <Switch>
              <Route exact path="/" component={LoginContainer} />
              <Route
                path="/retrievals-callback"
                component={RetrievalsCallbackContainer}
              />
              <Route
                exact
                path={`/session/login`}
                component={SessionLoginContainer}
              />
              <Route path="/session-reset" component={SessionResetContainer} />
              <Route path="/session/:sessionId" component={SessionSubRoute} />
              <Route path="/me" component={PortalSubRoute} />
              <Route path="/timeout" component={SessionTimeout} />
            </Switch>
          </Router>
        </Container>
      </React.Suspense>
    </AppInsightWrapper>
  );
};

export default App;
